<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn color="green" v-on="on">
                Добавить визит
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Добавить визит</span>
            </v-card-title>
            <v-card-text>
                <v-textarea auto-grow v-model="form.comment" label="Комментарий"></v-textarea>
                <v-alert v-if="form.errors.has('comment')" dense outlined type="error" :icon="false">
                    {{form.errors.get('comment') }}
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Отмена</v-btn>
                <v-btn color="blue darken-1" text @click="save">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Form from "../../_helpers/_form/Form";
    import ClientService from "../../_services/ClientService";

    export default {
        props: {id: Number},
        data() {
            return {
                form: new Form({}),
                dialog: false
            }
        },
        methods: {
            save() {
                ClientService.addVisit(this.id, this.form).then(() => {
                    this.dialog = false;
                    this.$emit('saved');
                });
            },
        }
    };
</script>
